import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TASK_CATEGORY_LABEL } from '../common';

interface Props {
  category: string;
}

export const CategoryChip: React.FC<Props> = ({ category }) => {
  const { t } = useTranslation();
  return (
    <Box
      style={{
        background: '#2169F51F',
        borderRadius: '16px',
        height: '24px',
        padding: '0 12px 0 12px',
      }}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
    >
      <Typography variant="body2" display="inline" style={{ color: '#2169F5', fontSize: '13px' }}>
        {t(TASK_CATEGORY_LABEL[category] ?? 'Unknown')}
      </Typography>
    </Box>
  );
};
